"use client";

import { cn } from "@/modern/utils";
import { getAccentBg } from "../advisorTheme";
import type { Persona } from "../context/AnalyzeFileContext";

/** Shared left accent column for feed rows (sticky header, insight cards, generating state). */
export const AdvisorAccentBar = ({ personaId }: { personaId: Persona["id"] }) => (
  <div className={cn("w-1 shrink-0 self-stretch", getAccentBg(personaId))} aria-hidden />
);
